import { createContext, ReactNode } from 'react';

interface ThemeContextType {
  isDark: boolean;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

// Simplified theme provider - always dark mode
export function ThemeProvider({ children }: ThemeProviderProps) {
  // Always return dark mode
  const isDark = true;

  // No-op function for backward compatibility
  const toggleTheme = () => {
    // Theme toggle disabled - always dark mode
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
